//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../Features/Features.SelectFeatureList.js";
import "../Features/Features.ViewVolumeListItemBuilderList.js";
import "../no/SelectObjectList.js";
import "../no/ObjectList.js";
let d=[[[1,"EnvironmentTarget",0,"Features.SelectFeatureList",0],[0,"Standard",1,0],[0,"VehicleLevel",1,0],[1,"ViewVolumeList",0,"Features.ViewVolumeListItemBuilderList",0]],[[[],"CreateViewVolumeListItemBuilder",{R_:{listitem:"Features.ViewVolumeListItemBuilder"}},0,0]],[]];
SPLM.Features.VolumetricAnalysisBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.VolumetricAnalysisBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.VolumetricAnalysisBuilder.Vehicle = Object.freeze({
    "Level1" : "Level1", "Level2" : "Level2", "Level3" : "Level3"});

export default SPLM;